import { render } from "./Funding.vue?vue&type=template&id=fe83df34"
import script from "./Funding.vue?vue&type=script&lang=js"
export * from "./Funding.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__